import React from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Box, Button, IconButton, Typography } from '@myn/mui';

type Props = {
  handleClose: () => void;
  handleConfirm: () => void;
};

const Title: React.FC<Props> = ({ handleClose, handleConfirm }) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mb: '16px',
      }}
    >
      <Box sx={{ display: 'flex', gap: (theme) => theme.spacing(1) }}>
        <IconButton
          variant="icon"
          icon="Close"
          size="small"
          onClick={handleClose}
        />
        <Typography variant="h3">{t('Edit columns')}</Typography>
      </Box>
      <Button
        color="primary"
        variant="contained"
        size="medium"
        onClick={handleConfirm}
      >
        {t('Confirm')}
      </Button>
    </Box>
  );
};

export default Title;
